export default __webpack_public_path__ + "static/browser-b3d17622ed10d33d48508eb54a9aaf6d.png";